import {createContext, use} from 'react'

export type NinetailedConfig = {
  clientId: string
  environment: string
  locale: string
} | null

const InternalNinetailedConfigContext = createContext<NinetailedConfig>(null)

export function NinetailedConfigContext({children, value}: {children: React.ReactNode; value: NinetailedConfig}) {
  return <InternalNinetailedConfigContext value={value}>{children}</InternalNinetailedConfigContext>
}

export function useNinetailedConfig(): NinetailedConfig {
  return use(InternalNinetailedConfigContext)
}
